import { FilterQuery } from '@yes.technology/react-toolkit'
import capitalize from 'lodash/capitalize'
import { useCallback, useState } from 'react'
import { useFetchYesObjects } from 'yesObject/shared'
import { FilteredItemsProps } from '../../FilterableMap.types'
import { getFilterableMapQuery } from '../../utils/getFilterableMapQuery'

type UseFilterableMapProps = {
  filteractionUuid: string
  objectclassUuid: string
  country: string
}

const useFilterableMapQuery = ({
  filteractionUuid,
  objectclassUuid,
  country
}: UseFilterableMapProps) => {
  const [query, setQuery] = useState<FilterQuery>(
    getFilterableMapQuery(capitalize(country))
  )

  const { isLoading, yesObjects: items } =
    useFetchYesObjects<FilteredItemsProps>({
      filteractionUuid,
      initialPagination: { limit: 100, offset: 0 },
      initialSortOptions: [],
      filterBody: {
        query,
        objectclass: objectclassUuid
      },
      shouldMergeFilters: true,
      showLoading: false
    })

  const updateQuery = useCallback((obs: string) => {
    setQuery(getFilterableMapQuery(obs))
  }, [])

  return {
    isLoading,
    items,
    updateQuery
  }
}

export default useFilterableMapQuery
